// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore // FIXME:
import * as pathBroserify from 'path-browserify'

export default {
  join (...paths: string[]): string {
    return pathBroserify.join(...paths)
  },
  dirname (path: string): string {
    return pathBroserify.dirname(path)
  }
}
